import React, { useEffect, useMemo, useState } from "react";
import { api, API, getToken } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Search, Download } from "lucide-react";

export default function Audit() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [date, setDate] = useState("");

  useEffect(() => { api.get("/audit").then((r) => setRows(r.data)); }, []);

  const filtered = useMemo(() => {
    return rows.filter((r) => {
      const matchQ = !q || `${r.user_name || ""} ${r.user_email || ""} ${r.action}`.toLowerCase().includes(q.toLowerCase());
      const matchD = !date || (r.timestamp || "").slice(0, 10) === date;
      return matchQ && matchD;
    });
  }, [rows, q, date]);

  return (
    <div className="space-y-6" data-testid="audit-page">
      <div className="flex items-center justify-between">
        <div><h1 className="font-heading text-3xl font-bold tracking-tight">Audit Log</h1><p className="mt-1 text-muted-foreground">Trace every important action by user and date.</p></div>
        <a href={`${API}/audit/export?auth=${getToken()}`} download><Button variant="secondary" data-testid="audit-export-btn"><Download className="mr-2 h-4 w-4" />Export CSV</Button></a>
      </div>
      <Card className="flex flex-wrap gap-3 p-4">
        <div className="relative flex-1 min-w-[220px]">
          <Search className="absolute left-3 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input placeholder="Search user or action…" value={q} onChange={(e) => setQ(e.target.value)} className="pl-9" data-testid="audit-search" />
        </div>
        <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="w-44" data-testid="audit-date" />
      </Card>
      <Card className="overflow-x-auto">
        <Table>
          <TableHeader><TableRow><TableHead>Date / Time</TableHead><TableHead>User</TableHead><TableHead>Action</TableHead><TableHead>Object</TableHead></TableRow></TableHeader>
          <TableBody>
            {filtered.length === 0 && <TableRow><TableCell colSpan={4} className="py-10 text-center text-muted-foreground">No log entries.</TableCell></TableRow>}
            {filtered.map((r) => (
              <TableRow key={r.id} data-testid={`audit-row-${r.id}`}>
                <TableCell className="font-mono text-xs">{new Date(r.timestamp).toLocaleString()}</TableCell>
                <TableCell>{r.user_name || r.user_email || "—"}</TableCell>
                <TableCell className="font-medium">{r.action}</TableCell>
                <TableCell className="text-muted-foreground">{r.object_type}{r.object_id ? ` · ${r.object_id.slice(0, 8)}` : ""}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
